import EnhancedTab from 'lib/designSystem/TabSimulation';
import { Warranty } from 'lib/types/models';
import File from 'pages/Finance/Components/Financing/SGR/components/File';
import React from 'react';

import WarrantySummary from './WarrantySummary';

const WarrantyDetailTabs: React.FC<{
  warranty: Warranty & { documents: Document[] };
}> = ({ warranty }) => {
  const tabs = [
    {
      label: 'Resumen',
      component: <WarrantySummary warranty={warranty} />,
    },
    {
      label: 'Documento',
      component: <File warranty={warranty} />,
    },
  ];

  return <EnhancedTab tabs={tabs} />;
};

export default WarrantyDetailTabs;
